import React from 'react'
import NumberFormat  from 'react-number-format'
import r from 'reactotron-react-js'

export const getCategory = (listCategories) => (catCode) => {
  return listCategories.find(c => c.code === catCode)
}

export const getSubCategory = (listSubCategories) => (subCatCode) => {
  return listSubCategories.find(s => s.code === subCatCode)
}

export const getOptionTitle = (options, value, displayWithValue = true) => {
  if (value !== undefined) {
    const opt = options && options.find(o => o.value === value)
    let result = opt ? opt.text : value
    if(result){
      result = result.replace(`:`, '|')
      return displayWithValue ? result : result.replace(`${value} | `, '')
    }else{
      return ''
    }
  } else {
    return ''
  }
}

export const filterStorageLocation = (storageLocationOptions) => (plantCode) => {
  if (storageLocationOptions !== undefined && plantCode !== undefined && plantCode !== '') {
    var result = storageLocationOptions.filter(s => s.plantCode === plantCode)
    result = result.sort((a, b) => (a.value < b.value) ? -1 : 1)
    return result
  } else {
    return []
  }
}

export const numberFormat = (value, allowNegative = false, decimalScale = 2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}

export const calculateTotalAmount = (items, change,isSumOnly=false) => {
  var total = 0
  items.map(i => total = total + (!i.deleted?(i.quantity * i.unitPrice):0))
  if (change) change('totalAmount', total)
  
  if(!isSumOnly) return numberFormat(total)
}

export const calculateVat = (items, vat, change,isSumOnly=false) => {
  let vatAmount = 0
  items.map(i => vatAmount = vatAmount + (!i.deleted?((i.quantity * i.unitPrice) / 100):0) * vat)
  if (change) change('vatAmount', vatAmount)
  
  if(!isSumOnly) return numberFormat(vatAmount)
}

export const calculateTotalIncludeVat = (items, vat, change,isSumOnly=false) => {
  let total = 0
  items.map(i => total = total + ((!i.deleted?(i.quantity * i.unitPrice):0) + ((!i.deleted?((i.quantity * i.unitPrice) / 100):0) * vat)))
  if (change) change('totalAmountIncludeVat', total)

  if(!isSumOnly) return numberFormat(total)
}

export const getDocumentTypes = (attachmentType, isSpecial, isAdditional) => {
  let documentTypes = []
  if (attachmentType && attachmentType.documentTypes) {
    documentTypes = JSON.parse(JSON.stringify(attachmentType.documentTypes))
  }
  
  if (isAdditional && attachmentType && attachmentType.additionalDocumentTypes.length !== 0) {
    documentTypes = JSON.parse(JSON.stringify(attachmentType.additionalDocumentTypes))
  }
  
  if (isSpecial) {
    if (documentTypes.length > 0) {
      const index = documentTypes.findIndex(dt => dt.code === 'PR07')
      if (index !== -1) {
        documentTypes[index].isRequire = true
      } else {
        documentTypes.push({ name: 'Quotation/Invoice', code: 'PR07', isRequire: true })
      }
    } else {
      documentTypes.push({ name: 'Quotation/Invoice', code: 'PR07', isRequire: true })
    }
  }

  documentTypes = documentTypes.sort((a, b) => (a.isRequire === b.isRequire)? 0 : !a.isRequire? 1 : -1)

  return documentTypes
}